import { WidgetHeight } from "@arelia-types/widget";

export const CONSTANTS = {
  UI_MESSAGES: {
    UNKNOWN_ERROR: "Unknown error. Please try again later.",
    GET_FETCH_ERROR:
      "An error occurred while retrieving data from the server. Please try again later.",
    DISTROKID_AUTH_ERROR:
      "Please use Arelia application to get data from DistroKid.",
    AUTH_ERROR: "Please connect to external service(s) for data access.",
  },
  GRID_LAYOUT: {
    COLUMNS: 12,
    GAP: 20,
    COEFFICIENT: 1.2,
    MIN_ROW_HEIGHT: (155 - 20 * 2) / WidgetHeight.S, // (expected minHeight for widget - gap * gaps quantity) / WidgetHeight.S
  },
  ICON_SX: { width: 18, height: 18 },
};

export enum EarningsPeriod {
  "Week" = "Week",
  "Month" = "Month",
  "Year" = "Year",
  "LastYear" = "LastYear",
  "All" = "All"
}

export type PeriodDisplay = {
  dropDownDisplay: string;
  menuLabelDisplay: string;
  timespanDisplay?: string;
}

export const EarningsPeriodDisplay: Record<EarningsPeriod, PeriodDisplay> = {
  [EarningsPeriod.Week]: {
    dropDownDisplay: "This Week",
    menuLabelDisplay: "Week",
    timespanDisplay: "Week"
  },
  [EarningsPeriod.Month]: {
    dropDownDisplay: "This Month",
    menuLabelDisplay: "Month",
    timespanDisplay: "Month"
  },
  [EarningsPeriod.Year]: {
    dropDownDisplay: "This Year",
    menuLabelDisplay: "Year",
    timespanDisplay: "Year"
  },
  [EarningsPeriod.LastYear]: {
    dropDownDisplay: "Last Year",
    menuLabelDisplay: "Last Year",
    timespanDisplay: "Period"
  },
  [EarningsPeriod.All]: {
    dropDownDisplay: "All",
    menuLabelDisplay: "All"
  }
};

export enum DashboardPeriod {
  "Month" = "Month",
  "Quarter" = "Quarter",
  "Year" = "Year",
  "All" = "All"
}

export const DashboardPeriodDisplay: Record<DashboardPeriod, PeriodDisplay> = {
  [DashboardPeriod.Month]: {
    dropDownDisplay: "This Month",
    menuLabelDisplay: "Month",
    timespanDisplay: "Month"
  },
  [DashboardPeriod.Quarter]: {
    dropDownDisplay: "This Quarter",
    menuLabelDisplay: "Quarter",
    timespanDisplay: "Quarter"
  },
  [DashboardPeriod.Year]: {
    dropDownDisplay: "This Year",
    menuLabelDisplay: "Year",
    timespanDisplay: "Year"
  },
  [DashboardPeriod.All]: {
    dropDownDisplay: "All",
    menuLabelDisplay: "All"
  }
};